import Head from 'next/head';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { ParsedUrlQuery } from 'querystring';
import previewMain from '../../public/preview/preview-main.png';
import BlogPage from './blog';
import {
  getAllArticles,
  getQuote,
  getThemes,
} from '../../services/blog.service';
import { BlogProps } from './blog.types';
import { Footer, Header } from '../../components';
import menu from '../../utils/menu';

export default function Blog({ articles, themes, quote }: BlogProps) {
  return (
    <>
      <Head>
        <title>
          Mavinx Blog - Insights, Trends, and Expertise in Technology and
          Business
        </title>
        <meta
          property="og:title"
          content="Mavinx Blog - Insights, Trends, and Expertise in Technology and
          Business"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="Mavinx Blog - Insights, Trends, and Expertise in Technology and
          Business"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="The Mavinx Blog offers insights, technological trends, and specialist expertise in software development, digital transformation, and consulting services. Discover thought-provoking articles, industry analysis, and practical suggestions to help organizations manage the ever-changing technology world. Use Mavinx's experience to innovate and succeed."
        />
        <meta
          name="description"
          content="The Mavinx Blog offers insights, technological trends, and specialist expertise in software development, digital transformation, and consulting services. Discover thought-provoking articles, industry analysis, and practical suggestions to help organizations manage the ever-changing technology world. Use Mavinx's experience to innovate and succeed."
        />
        <meta
          name="keywords"
          content="Mavinx blog, technology insights, industry trends, business expertise, software development, digital transformation, consulting services"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <BlogPage articles={articles} themes={themes} quote={quote} />
      <Footer />
    </>
  );
}

export const getServerSideProps: GetServerSideProps<
  BlogProps,
  ParsedUrlQuery
> = async ({ query }: GetServerSidePropsContext<ParsedUrlQuery>) => {
  try {
    const articles = await getAllArticles(query);
    const themes = await getThemes();
    const quote = await getQuote();

    return {
      props: {
        articles,
        themes,
        quote,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};
